import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-device-marketing',
    templateUrl: './device-marketing.component.html',
    styleUrls: ['./device-marketing.component.scss'],
    standalone: false
})
export class DeviceMarketingComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      deviceStatus: ['', { validators: [] }],
      notIntendedForEu: ['', { validators: [] }],
      memberStateForDevicePlacementInEu: ['', { validators: [] }],
      deviceRecallScope: ['', { validators: [] }],
      membersAvailForm: this.fb.array([this.addMemberAvailForm()]),
      subStatusForm: this.fb.array([this.addSubStatusForm()]),
      recallForm: this.fb.array([this.addRecallForm()]),
      commercialDistributionEndDate: ['', { validators: [] }],
      reasonForDeviceDiscontinuation: ['', { validators: [] }],
      customerServiceCenterName: ['', { validators: [] }],
      customerServiceCenterPhone: ['', { validators: [] }],
      medicalInsuranceCodesForm: this.fb.array([this.addMedicalInsuranceCodesForm()]),
      healthBenefitCodesForm: this.fb.array([this.addHealthBenefitCodesForm()]),
      premarketAuthorizationForm: this.fb.array([this.addPremarketAuthorizationForm()]),
      fdaListingNumbersForm: this.fb.array([this.addFdaListingNumbersForm()]),
      customerContactForm: this.fb.array([this.addCustomerContactForm()]),
      eligibleForHealthCareBenefitsOrReimbursement: ['', { validators: [] }],
      reasonForNotProvidingHealthCareBenefitCode: ['', { validators: [] }],
      newDevice: ['', { validators: [] }],
      premarketAuthorizationExempt: ['', { validators: [] }],
      prescriptionUseRx: ['', { validators: [] }],
      overTheCounterOtc: ['', { validators: [] }],
      artgForm: this.fb.array([this.addArtgForm()])
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  get medicalInsuranceCodesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('medicalInsuranceCodesForm');
  }

  get healthBenefitCodesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('healthBenefitCodesForm');
  }

  get membersAvailForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('membersAvailForm');
  }

  get subStatusForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('subStatusForm');
  }

  get recallForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('recallForm');
  }

  get premarketAuthorizationForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('premarketAuthorizationForm');
  }

  get fdaListingNumbersForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('fdaListingNumbersForm');
  }

  get customerContactForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('customerContactForm');
  }
  get artgForm(): FormArray {
    return this.deviceForm.get('artgForm') as FormArray;
  }
  addMedicalInsuranceCodesForm(): any {
    return this.fb.group({
      value: ['', { validators: [] }]
    });
  }

  addCustomerContactForm(): any {
    return this.fb.group({
      email: ['', { validators: [] }],
      telCountryCode: ['', { validators: [] }],
      telNumber: ['', { validators: [] }],
      extension: ['', { validators: [] }]
    });
  }

  addPremarketAuthorizationForm(): any {
    return this.fb.group({
      authorizationNumber: ['', { validators: [] }],
      supplementNumber: ['', { validators: [] }]
    });
  }

  addHealthBenefitCodesForm(): any {
    return this.fb.group({
      value: ['', { validators: [] }]
    });
  }

  addFdaListingNumbersForm(): any {
    return this.fb.group({
      fdaListingNumber: ['', { validators: [] }]
    });
  }

  addSubStatusForm(): FormGroup {

      return this.fb.group({
          subStatusValue: ['', { validators: [] }],
          subStatusStartDate: ['', { validators: [] }],
          subStatusEndDate: ['', { validators: [] }]
      });
  }

  addRecallForm(): FormGroup {

    return this.fb.group({
      value: ['', { validators: [] }],
      languageQualifier: ['', { validators: [] }]
    });
  }

  addMemberAvailForm(): FormGroup {

    return this.fb.group({
      memberStateValue: ['', { validators: [] }],
      startDate: ['', { validators: [] }],
      endDate: ['', { validators: [] }]
    });
  }
  addArtgForm(): FormGroup {
    return this.fb.group({
      artgId: ['', { validators: [] }],
      supportingDocumentUrl: ['', { validators: [] }],
      supportingDocumentType: ['', { validators: [] }],
      supportingDocumentEffectiveDate: ['', { validators: [] }],
      supportingDocumentEndDate: ['', { validators: [] }]
    });
  }

  patchForms() {

    this.deviceForm.patchValue({

      deviceStatus: this.displayItemData('Device Status'),
      notIntendedForEu: this.displayItemData('Not intended for being placed on the EU market?'),
      deviceRecallScope: this.displayItemData('Device Recall Scope'),
      memberStateForDevicePlacementInEu: this.displayItemData('Member State Where Device is Placed on the EU Market'),
      commercialDistributionEndDate: this.displayItemData('Commercial Distribution End Date'),
      reasonForDeviceDiscontinuation: this.displayItemData('Reason for Device Discontinuation'),
      customerServiceCenterName: this.displayItemData('Customer Service Center Name'),
      customerServiceCenterPhone: this.displayItemData('Customer Service Center Phone Number'),
      medicalInsuranceCode: this.displayItemData('Medical Insurance Code'),
      eligibleForHealthCareBenefitsOrReimbursement: this.displayItemData('Eligible for Health Care Benefit or Reimbursement?'),
      reasonForNotProvidingHealthCareBenefitCode: this.displayItemData('Reason for Not Providing Health Care Benefit Code'),
      newDevice: this.displayItemData('New Device?'),
      premarketAuthorizationExempt: this.displayItemData('Device Exempt from FDA Premarket Submission?'),
      prescriptionUseRx: this.displayItemData('Prescription Use (Rx)?'),
      overTheCounterOtc: this.displayItemData('Over the Counter (OTC)?')
    });

    this.deviceForm.setControl('membersAvailForm', this.setMemberAvailForm());
    this.deviceForm.setControl('subStatusForm', this.setSubStatusForm());
    this.deviceForm.setControl('recallForm', this.setRecallForm());
    this.deviceForm.setControl('healthBenefitCodesForm', this.setHealthBenefitCodesForm());
    this.deviceForm.setControl('premarketAuthorizationForm', this.setPremarketAuthorizationForm());
    this.deviceForm.setControl('fdaListingNumbersForm', this.setFdaListingNumbersForm());
    this.deviceForm.setControl('customerContactForm', this.setCustomerContactForm());
    this.deviceForm.setControl('medicalInsuranceCodesForm', this.setMedicalInsuranceCodesForm());
    this.deviceForm.setControl('artgForm', this.setArtgForm());
  }

  setMedicalInsuranceCodesForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;

    items = this.displayItemData('Medical Insurance Code(s)');

    if (items && items.length > 0) {
      items.forEach((code, i) => {
        formArray.push(

          this.fb.group({
            medicalInsuranceCode: code[(this.getMapInnerPathName('Medical Insurance Code'))[0]]
          })
        );
      });
    }

    return formArray;
  }


  setCustomerContactForm(): FormArray {

    const formArray = new FormArray([]);

    let contact: any;

    contact = this.displayItemData('Customer Contact');

    if (contact && contact.length) {
      contact.forEach(c => {

        formArray.push(

          this.fb.group({
            email: c[(this.getMapInnerPathName('Customer Contact Email'))[0]],
            telCountryCode: c[(this.getMapInnerPathName('Customer Telephone Country Code'))[0]],
            telNumber: c[(this.getMapInnerPathName('Customer Telephone Number'))[0]],
            extension: c[(this.getMapInnerPathName('Customer Telephone Ext'))[0]]
          })
        );
      });
    }

    return formArray;
  }


  setHealthBenefitCodesForm(): FormArray {

    const formArray = new FormArray([]);

    let codes: any;

    codes = this.displayItemData('Health Care Benefit Code(s)');

    if (codes && codes.length) {
      codes.forEach(c => {

          formArray.push(

                this.fb.group({
                  value: c[(this.getMapInnerPathName('Health Care Benefit Code Value'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setMemberAvailForm(): FormArray {

    const formArray = new FormArray([]);

    let members: any;

    members = this.displayItemData('Member State(s) Where Device is Made Available');

    if (members && members.length > 0) {
      members.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  memberStateValue: c[(this.getMapInnerPathName('Member State Value'))[0]],
                  startDate: c[(this.getMapInnerPathName('Availability Start Date'))[0]],
                  endDate: c[(this.getMapInnerPathName('Availability End Date'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setSubStatusForm(): FormArray {

    const formArray = new FormArray([]);

    let status: any;

    status = this.displayItemData('Device SubStatus');

      if (status) {
          status.forEach((c, i) => {
      formArray.push(

        this.fb.group({
            subStatusValue: c[(this.getMapInnerPathName('Device SubStatus Value'))[0]],
            subStatusStartDate: c[(this.getMapInnerPathName('Device SubStatus Start Date'))[0]],
            subStatusEndDate: c[(this.getMapInnerPathName('Device SubStatus End Date'))[0]]
        })

              );
          });
    }
    return formArray;
  }

  setRecallForm(): FormArray {

    const formArray = new FormArray([]);

    let recalls: any;

    recalls = this.displayItemData('Device Recall Precision');

    if (recalls && recalls.length > 0) {
      recalls.forEach((c, i) => {

          formArray.push(

                this.fb.group({
                  value: c[(this.getMapInnerPathName('Device Recall Precision Value'))[0]],
                  languageQualifier: c[(this.getMapInnerPathName('Device Recall Precision Language'))[0]]
                })
            );
        });
    }

    return formArray;
  }

  setPremarketAuthorizationForm(): FormArray {

    const formArray = new FormArray([]);

    let premarketAuth: any;

    premarketAuth = this.displayItemData('FDA Premarket Authorization');

    if (premarketAuth && premarketAuth.length > 0) {
      premarketAuth.forEach((c, i) => {

        formArray.push(

          this.fb.group({
            authorizationNumber: c[(this.getMapInnerPathName('FDA Authorization Number'))[0]],
            supplementNumber: c[(this.getMapInnerPathName('FDA Supplement Number'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setFdaListingNumbersForm(): FormArray {

    const formArray = new FormArray([]);

    let listings: any;

    listings = this.displayItemData('FDA Listing Number(s)');

    if (listings && listings.length > 0) {
      listings.forEach((c, i) => {

        formArray.push(

          this.fb.group({
            fdaListingNumber: c[(this.getMapInnerPathName('FDA Listing Number Value'))[0]]
          })
        );
      });
    }

    return formArray;
  }

  setArtgForm(): FormArray {
    const formArray = new FormArray([]);
    const artgEntries = this.displayItemData('ARTG ID');

    if (artgEntries && Array.isArray(artgEntries) && artgEntries.length > 0) {
      artgEntries.forEach((entry: any) => {
        const artgId =
          entry?.[this.getMapInnerPathName('ARTG ID Value')[0]] || '';
        const docPath = this.getMapInnerPathName('Supporting Document URL')[0];
        const supportingDocs = entry?.[docPath]?.supportingDocument || [];
        if (supportingDocs.length === 0) {
          formArray.push(
            this.fb.group({
              artgId,
              supportingDocumentUrl: '',
              supportingDocumentType: '',
              supportingDocumentEffectiveDate: '',
              supportingDocumentEndDate: ''
            })
          );
        }
        else {
          supportingDocs.forEach((doc: any) => {
            formArray.push(
              this.fb.group({
                artgId,
                supportingDocumentUrl:
                  doc?.[this.getMapInnerPathName('Supporting Document URL Value')[0]] || '',
                supportingDocumentType:
                  doc?.[this.getMapInnerPathName('Supporting Document Type')[0]] || '',
                supportingDocumentEffectiveDate:
                  doc?.[this.getMapInnerPathName('Supporting Document Effective Date')[0]] || '',
                supportingDocumentEndDate:
                  doc?.[this.getMapInnerPathName('Supporting Document End Date')[0]] || ''
              })
            );
          });
        }
      });
    }

    return formArray;
  }
}
